import createManagementPageLifecycle from "@shared/createManagementPageLifecycle.cjs";

export default createManagementPageLifecycle({
  navbar: "1-1",
  navbarHook: "mounted",
  loadMethods: ["loadSchedules"],
});
